/**
 * Converts an array path to a string path with proper bracket notation
 * for property names containing dots or special characters.
 *
 * This is essential for React Final Form compatibility - formApi.change()
 * requires string paths, but property names with dots must use bracket notation
 * to avoid incorrect path interpretation.
 *
 * @param pathArray - Array of path segments (e.g., ["arguments.link", "href"])
 * @returns String path with bracket notation (e.g., '["arguments.link"].href')
 *
 * @example
 * arrayPathToFormPath(["arguments.link", "href"])
 * // Returns: '["arguments.link"].href'
 *
 * @example
 * arrayPathToFormPath(["carousel", "items", "0", "title"])
 * // Returns: '.carousel.items.0.title'
 */
export const arrayPathToFormPath = (pathArray?: PropertyKey[]): string =>
  (pathArray ?? []).reduce<string>((acc, part) => {
    if (typeof part === 'symbol') return acc;
    const needsBracket = typeof part === 'string' && (part.includes('.') || /[^a-zA-Z0-9_$]/.test(part));
    if (!acc) return needsBracket ? `["${part}"]` : `.${part}`;
    return needsBracket ? `${acc}["${part}"]` : `${acc}.${part}`;
  }, '');
